import { AfterViewInit, Component, OnInit, ViewChild, Input, OnChanges, SimpleChange, SimpleChanges, ElementRef, LOCALE_ID, Inject } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import { ConfigService } from '../services/config.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialog } from '../dialogs/alert-dialog';
import { RefertiListDataSource } from './referti-list-datasource';
import { Referto } from '../models/referto';
import { MainService } from '../services/main.service';
import { BackendService } from '../services/backend.service';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-referti-list',
  templateUrl: './referti-list.component.html',
  styleUrls: ['./referti-list.component.css']
})
export class RefertiListComponent implements AfterViewInit, OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<Referto>;

  @ViewChild('fPazienteSpan') fPazienteSpan: ElementRef;


  dataSource: RefertiListDataSource;

  displayedColumns = ['descReferto', 'btn1', 'btn2'];

  constructor(private configService: ConfigService, public mainService: MainService,
    private sanitizer: DomSanitizer, private dialog: MatDialog,
    private backendService: BackendService,
    @Inject(LOCALE_ID) private locale: string
  ) {

  }

  ngOnInit() {
    this.dataSource = new RefertiListDataSource(this.configService, this.mainService);
  }

  ngAfterViewInit() {
    this.configService.ensureConfig().subscribe(() => {
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.table.dataSource = this.dataSource;

      this.setNominativoPaziente();

    });
  }

  protected setNominativoPaziente() {
    if (this.mainService.getReferti() != null) {
      var referti: Referto[] = this.mainService.getReferti();
      if (referti != null && referti.length > 0) {
        var nominativo = `Paziente: ${referti[0].cogPaziente} ${referti[0].nomePaziente}`;
        (<HTMLSpanElement>this.fPazienteSpan.nativeElement).innerText = nominativo;
      }
    }
  }


  public getDescReferto(ref: Referto): string {
    var dtrs = ref.dataReferto ? formatDate(ref.dataReferto, 'dd/MM/yyyy', this.locale) : formatDate(ref.datRichiesta, 'dd/MM/yyyy', this.locale);
    var idf = `${ref.numAccettazione ? ref.numAccettazione : ref.repNumber}/${ref.prgReferto}`;
    return `Referto ${idf} ${dtrs ? ('del ' + dtrs) : ''} ${ref.descPrestazione ? ('per ' + ref.descPrestazione) : ''}`;
  }

  public onButtonReferto(ref: Referto) {
    console.log(`clicked btn1 on ${JSON.stringify(ref)}`);
    this.mainService.createReportObject(ref);
    //  this.createReportObject(ref);
  }

  public onButtonImmagini(ref: Referto) {
    console.log(`clicked btn1 on ${JSON.stringify(ref)}`);
    this.mainService.createImmaginiObject(ref);
    //  this.createImmaginiObject(ref);
  }

  /*
  private createReportObject(ref: Referto, container?: HTMLDivElement) {
    let url = this.configService
      .getBackendUrl(`/getContentReferto?oper=referto&codSede=${this.mainService.getSede()}&uid=${ref.repUid}&scope=${this.mainService.getScope()}&codPaziente=${this.mainService.getCodPaziente()}&token=${ref.tokenId}`);
    window.open(url, '_blank');
  }

  private createImmaginiObject(ref: Referto, container?: HTMLDivElement) {
    this.backendService.getUrlImmaginiReferto(this.mainService.getScope(), this.mainService.getCodPaziente(), this.mainService.getSede(), ref).subscribe((url:string) => {
      console.log(`opening url ${url}`);
      window.open(url, '_blank');
    });
  }
  */


}
